// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__jC-jR","modalHeader":"styles_modalHeader__i2vTS","popularColumns":"styles_popularColumns__7cLE2","content":"styles_content__GRLzZ"};